import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6 py-16">
      <div className="max-w-md w-full text-center fade-up border border-black/10 bg-surface p-10">
        <XCircle size={56} weight="duotone" className="text-muted-foreground mx-auto mb-6" />
        <h1 className="font-head text-3xl mb-3">Checkout Cancelled</h1>
        <p className="text-muted-foreground mb-8">No charge was made. Your cart is still saved.</p>
        <Link to="/cart" data-testid="back-to-cart-btn" className="inline-block bg-primary text-black label-mono py-4 px-8">Return to Cart</Link>
      </div>
    </div>
  );
}
